"use client";
import { useState } from "react";
import type { SizeGuide as SizeGuideData } from "@/lib/validations/cms";

export default function SizeGuide({ data }: { data: SizeGuideData }) {
  const [open, setOpen] = useState(false);
  if (!data.enabled) return null;
  return (
    <>
      <button onClick={() => setOpen(true)} className="text-xs underline tracking-widest uppercase">{data.label}</button>
      {open && (
        <button type="button" className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={() => setOpen(false)} aria-label="Close size guide">
          <div className="bg-background max-w-lg w-full border p-6" onClick={(e) => e.stopPropagation()} role="presentation">
            <h3 className="font-bold tracking-widest uppercase text-sm mb-2">{data.title}</h3>
            {data.description && <p className="text-xs text-muted-foreground mb-4">{data.description}</p>}
            <table className="w-full text-xs border-collapse">
              <thead><tr className="border-b font-bold">{data.columns.map((c) => <th key={c} className="p-2 text-left first:text-left text-center">{c}</th>)}</tr></thead>
              <tbody>
                {data.rows.map((row, i) => (
                  <tr key={i} className="border-b last:border-0">{row.map((cell, j) => <td key={j} className="p-2 text-center first:text-left">{cell}</td>)}</tr>
                ))}
              </tbody>
            </table>
            <button type="button" onClick={() => setOpen(false)} className="mt-4 w-full bg-foreground text-background py-2 text-xs tracking-widest uppercase">Close</button>
          </div>
        </button>
      )}
    </>
  );
}
